// A pragmatic list of NSW train/metro stations covering Sydney Trains,
// NSW TrainLink Intercity & Regional, and Sydney Metro.  Not exhaustive —
// covers stations passengers actually see on PIDs.

export const STATIONS = [
  // Sydney CBD & Inner
  "Central", "Town Hall", "Wynyard", "Circular Quay", "St James", "Museum",
  "Martin Place", "Kings Cross", "Edgecliff", "Bondi Junction", "Erskineville",
  "St Peters", "Sydenham", "Tempe", "Wolli Creek",

  // T1 North Shore
  "Milsons Point", "North Sydney", "Waverton", "Wollstonecraft", "St Leonards",
  "Artarmon", "Chatswood", "Roseville", "Lindfield", "Killara", "Gordon",
  "Pymble", "Turramurra", "Warrawee", "Wahroonga", "Waitara", "Hornsby",

  // T1/T9 Northern
  "Berowra", "Mount Kuring-gai", "Mount Colah", "Asquith", "Normanhurst",
  "Thornleigh", "Pennant Hills", "Beecroft", "Cheltenham", "Epping",
  "Eastwood", "Denistone", "West Ryde", "Meadowbank", "Rhodes", "Concord West",
  "North Strathfield", "Strathfield",

  // T1 Western
  "Redfern", "Macdonaldtown", "Newtown", "Stanmore", "Petersham", "Lewisham",
  "Summer Hill", "Ashfield", "Croydon", "Burwood", "Homebush", "Flemington",
  "Lidcombe", "Auburn", "Clyde", "Granville", "Harris Park", "Parramatta",
  "Westmead", "Wentworthville", "Pendle Hill", "Toongabbie", "Seven Hills",
  "Blacktown", "Marayong", "Quakers Hill", "Schofields", "Tallawong",
  "Riverstone", "Vineyard", "Mulgrave", "Windsor", "Clarendon", "East Richmond",
  "Richmond",

  // T1/Blue Mountains
  "Doonside", "Rooty Hill", "Mount Druitt", "St Marys", "Werrington",
  "Kingswood", "Penrith", "Emu Plains", "Lapstone", "Glenbrook", "Blaxland",
  "Warrimoo", "Valley Heights", "Springwood", "Faulconbridge", "Linden",
  "Woodford", "Hazelbrook", "Lawson", "Bullaburra", "Wentworth Falls",
  "Leura", "Katoomba", "Medlow Bath", "Blackheath", "Mount Victoria",
  "Bell", "Zig Zag", "Lithgow", "Bathurst", "Orange",

  // T2 Inner West & Leppington
  "Macarthur", "Campbelltown", "Leumeah", "Minto", "Ingleburn", "Macquarie Fields",
  "Glenfield", "Casula", "Liverpool", "Warwick Farm", "Cabramatta", "Canley Vale",
  "Fairfield", "Yennora", "Guildford", "Merrylands", "Edmondson Park", "Leppington",

  // T3 Bankstown (legacy)
  "Marrickville", "Dulwich Hill", "Hurlstone Park", "Canterbury", "Campsie",
  "Belmore", "Lakemba", "Wiley Park", "Punchbowl", "Bankstown", "Yagoona",
  "Birrong", "Sefton", "Chester Hill", "Leightonfield", "Villawood", "Carramar",

  // T4 Eastern Suburbs & Illawarra
  "Hurstville", "Penshurst", "Mortdale", "Oatley", "Como", "Jannali",
  "Sutherland", "Loftus", "Engadine", "Heathcote", "Waterfall",
  "Allawah", "Carlton", "Kogarah", "Rockdale", "Banksia", "Arncliffe",
  "Bardwell Park", "Turrella",

  // T5 Cumberland
  "Carlingford", "Telopea", "Dundas", "Rydalmere", "Camellia", "Rosehill",
  "Sefton (Cumberland)",

  // T7 Olympic Park
  "Olympic Park",

  // T8 Airport & South
  "Green Square", "Mascot", "Domestic Airport", "International Airport",
  "Turrella ", "Bardwell Park ", "Bexley North", "Kingsgrove", "Beverly Hills",
  "Narwee", "Riverwood", "Padstow", "Revesby", "Panania", "East Hills",
  "Holsworthy", "Macquarie Fields ",

  // South Coast / Illawarra
  "Helensburgh", "Otford", "Stanwell Park", "Coalcliff", "Scarborough",
  "Wombarra", "Coledale", "Austinmer", "Thirroul", "Bulli", "Woonona",
  "Bellambi", "Corrimal", "Towradgi", "Fairy Meadow", "North Wollongong",
  "Wollongong", "Coniston", "Unanderra", "Kembla Grange", "Dapto",
  "Albion Park", "Oak Flats", "Dunmore", "Shellharbour Junction", "Minnamurra",
  "Bombo", "Kiama", "Gerringong", "Berry", "Bomaderry",

  // Southern Highlands
  "Picton", "Tahmoor", "Bargo", "Yerrinbool", "Mittagong", "Bowral",
  "Burradoo", "Moss Vale", "Exeter", "Bundanoon", "Wingello", "Penrose",
  "Tallong", "Goulburn",

  // Central Coast & Newcastle
  "Hornsby ", "Cowan", "Hawkesbury River", "Wondabyne", "Woy Woy",
  "Koolewong", "Tascott", "Point Clare", "Gosford", "Narara", "Niagara Park",
  "Lisarow", "Ourimbah", "Tuggerah", "Wyong", "Warnervale", "Wyee",
  "Morisset", "Dora Creek", "Awaba", "Fassifern", "Booragul", "Teralba",
  "Cockle Creek", "Cardiff", "Kotara", "Adamstown", "Broadmeadow",
  "Hamilton", "Wickham", "Newcastle Interchange",

  // Hunter line
  "Sandgate", "Hexham", "Tarro", "Beresfield", "Thornton", "Metford",
  "Maitland", "East Maitland", "Victoria Street", "High Street", "Telarah",
  "Farley", "Allandale", "Lochinvar", "Greta", "Branxton", "Singleton",
  "Muswellbrook", "Scone",

  // North Coast
  "Wauchope", "Kempsey", "Macksville", "Nambucca Heads", "Urunga",
  "Sawtell", "Coffs Harbour", "Grafton", "Casino", "Kyogle", "Murwillumbah",

  // Sydney Metro
  "Tallawong ", "Rouse Hill", "Kellyville", "Bella Vista", "Norwest",
  "Hills Showground", "Castle Hill", "Cherrybrook", "Macquarie University",
  "Macquarie Park", "North Ryde", "Crows Nest", "Victoria Cross", "Barangaroo",
  "Gadigal", "Waterloo",

  // NSW TrainLink extra regional stations
  // North Coast XPT
  "Border Loop", "Beaudesert", "Salisbury", "South Brisbane", "Roma Street",
  // Northern (Armidale / Moree)
  "Werris Creek", "Tamworth", "Uralla",
  // Western (Dubbo / Broken Hill)
  "Blayney", "Wellington", "Dubbo",
  // Southern XPT (Melbourne)
  "Yass Junction", "Cootamundra", "Junee", "Wagga Wagga", "The Rock",
  "Henty", "Culcairn", "Albury", "Wodonga", "Benalla", "Seymour",
  "Melbourne Southern Cross",
  // Griffith Xplorer
  "Harden", "Coolamon", "Ganmain", "Matong", "Grong Grong", "Narrandera",
  "Yanco", "Leeton", "Griffith",
  // Canberra Xplorer
  "Tarago", "Bungendore", "Queanbeyan", "Canberra",
  // Regional extras
  "Dungog", "Gloucester", "Wingham", "Taree", "Menangle Park", "Menangle",
  "Douglas Park",
];

// Dedupe (some appear in multiple lines marked with trailing space) and sort
const _unique = Array.from(
  new Set(STATIONS.map((s) => s.trim()))
).filter(Boolean).sort((a, b) => a.localeCompare(b));

export const STATIONS_UNIQUE = _unique;

export function searchStations(query, limit = 30) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return _unique.slice(0, limit);
  const starts = [];
  const contains = [];
  for (const s of _unique) {
    const lower = s.toLowerCase();
    if (lower.startsWith(q)) starts.push(s);
    else if (lower.includes(q)) contains.push(s);
    if (starts.length >= limit) break;
  }
  return [...starts, ...contains].slice(0, limit);
}
